export const QueryTypeAny = -1;
export const QueryViewTypeAny = -1;
export const QueryStatusTypeAny = -1;
export const QueryTypeDeletedDocuments = 1;

export enum QueryType {
  Workflow = 1,
  Audit = 2,
  General = 3,
  SSU = 4,
}

export enum QueryViewType {
  BySender = 1,
  ByRecipient = 2,
}

export enum QueryStatusType {
  Pending = 1,
  InProgress = 2,
  Resolved = 4,
}

export enum MyQueryFlags {
  On = 1,
  Off = 0,
}
